import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Alert} from '@material-ui/lab';
import SectionCard from './SectionCard';
import settingsStyles from '../settingsStyles';
import {
    getWebTemplateList,
    updateWebTemplate,
} from '../../../../../redux/actions/Web/Template/webTemplateActions';

// Tema id'lerine gore gorunen isimler (WebTemplateSelect ile ayni liste)
const THEME_NAMES = {
    1: 'Boutique',
    2: 'Stork',
    3: 'Oscar',
    4: 'Qlusive',
    5: 'Valencia',
    6: 'Solene',
    8: 'Folio',
};

export default function ThemeCard({currentTemplate, onSaved}) {
    const {t} = useTranslation();
    const classes = settingsStyles();
    const dispatch = useDispatch();

    const fetching = useSelector((state) => state.webTemplateReducer?.fetching);
    const listData = useSelector((state) => state.webTemplateReducer?.listData);
    const updateFetching = useSelector((state) => state.webTemplateReducer?.updateFetching);
    const updateData = useSelector((state) => state.webTemplateReducer?.updateData);

    const initialId = currentTemplate && currentTemplate.id ? currentTemplate.id : null;
    const [selectedId, setSelectedId] = useState(initialId);
    const [currentId, setCurrentId] = useState(initialId);

    useEffect(() => {
        dispatch(getWebTemplateList());
    }, [dispatch]);

    useEffect(() => {
        if (initialId) {
            setSelectedId(initialId);
            setCurrentId(initialId);
        }
    }, [initialId]);

    // Kayit tamamlandiginda mevcut temayi guncelle
    useEffect(() => {
        if (!updateFetching && updateData && updateData.status === 200 && !updateData.error) {
            const savedId = (updateData.data && updateData.data.template_id) || selectedId;
            setCurrentId(savedId);
            if (typeof onSaved === 'function') onSaved();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateFetching, updateData]);

    const templates = listData && listData.status === 200 && !listData.error && Array.isArray(listData.data)
        ? listData.data.filter((template) => template.status === 1)
        : [];

    const currentName = THEME_NAMES[currentId]
        || (templates.find((template) => template.id === currentId) || {}).name
        || '—';

    const handleSave = () => {
        if (updateFetching || selectedId === currentId) return;
        dispatch(updateWebTemplate({template_id: selectedId}));
    };

    return (
        <SectionCard
            id="tema"
            icon="fas fa-palette"
            title={t('enw-web-settings-theme_title', 'Tema')}
            description={t('enw-web-settings-theme_current', {
                defaultValue: 'Şu an {{name}} teması kullanılıyor',
                name: currentName,
            })}
            actions={
                <Button
                    className={`${classes.btn} ${selectedId !== currentId ? classes.btnPrimary : ''}`}
                    disabled={selectedId === currentId || updateFetching}
                    onClick={handleSave}
                >
                    {updateFetching
                        ? <CircularProgress size={16} style={{color: '#fff'}} />
                        : t('enw-web-settings-theme_save', 'Temayı Kaydet')}
                </Button>
            }
        >
            {fetching ? (
                <div className={classes.loadingBox}>
                    <CircularProgress size={28} style={{color: '#d71f26'}} />
                </div>
            ) : templates.length === 0 ? (
                <div style={{padding: 20}}>
                    <Alert severity="info">
                        {t('enw-web-settings-theme_empty', 'Gösterilecek tema bulunamadı.')}
                    </Alert>
                </div>
            ) : (
                <div className={classes.themeGrid}>
                    {templates.map((template) => {
                        const isSelected = selectedId === template.id;
                        const isCurrent = currentId === template.id;
                        const imgSrc = `${process.env.PUBLIC_URL}/assets/img/themes/theme_${template.folder_name}.png`;
                        return (
                            <button
                                type="button"
                                key={template.id}
                                aria-pressed={isSelected}
                                className={`${classes.themeCard} ${isSelected ? classes.themeCardActive : ''}`}
                                onClick={() => setSelectedId(template.id)}
                                disabled={updateFetching}
                            >
                                <img
                                    className={classes.themeShot}
                                    src={imgSrc}
                                    alt={THEME_NAMES[template.id] || template.name}
                                    loading="lazy"
                                />
                                <span className={`${classes.themeName} ${isSelected ? classes.themeNameActive : ''}`}>
                                    {THEME_NAMES[template.id] || template.name}
                                    {isCurrent && (
                                        <span className={classes.themeCurrent}>
                                            {t('enw-web-settings-theme_in_use', 'MEVCUT')}
                                        </span>
                                    )}
                                </span>
                            </button>
                        );
                    })}
                </div>
            )}
            <style>{`
                .MuiCircularProgress-indeterminate {
                    color: #fff;
                    position: relative !important;
                }
                button.Mui-disabled {
                   color:rgba(0, 0, 0, 0.26)!important;
                }
            `}</style>
        </SectionCard>
    );
}
